module.exports = __webpack_public_path__ + "img/page8img2.a5d1aae1.png";